import { render, staticRenderFns } from "./CaseView.vue?vue&type=template&id=c06c47ba&scoped=true&"
import script from "./CaseView.vue?vue&type=script&lang=js&"
export * from "./CaseView.vue?vue&type=script&lang=js&"
import style0 from "./CaseView.vue?vue&type=style&index=0&id=c06c47ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06c47ba",
  null
  
)

export default component.exports